export default{
    //SCHEDULE INTERVIEW
    "question.error.refresh"               : "Lo sentimos, el horario que ha seleccionado ya no está disponible. Elija otro horario de entre los siguientes",
    "question.error.char.exceeded"         : "El texto del comentario debe tener menos de 500 caracteres.",
    
    "question.message.completed.1"         : "Gracias por elegir un horario para la entrevista. Hemos enviado un correo electrónico desde qual@surveyhealthcareglobal.com para confirmar la hora y fecha de su sesión.",
    "question.message.italic"              : "Rogamos que lea atentamente todas las instrucciones y consulte al responsable del proyecto si tiene alguna duda.",
    "question.message.completed.2"         : "Los incentivos se abonan una vez finalizado el proyecto; el estudio puede durar varias semanas. El responsable de las reservas puede indicarle los horarios si se los solicita.",
    "question.message.completed.3"         : "Contacto para cancelar o reprogramar citas: qual@surveyhealthcareglobal.com, mencionando el número de confirmación para el proyecto.",
    "question.message.overquota.1"         : "Gracias por su interés en participar. Por desgracia, se han cubierto todas las plazas del estudio antes de lo previsto y no podemos aceptar más respuestas. Si se produjera algún cambio, se lo comunicaremos. Esperamos trabajar con usted en otra ocasión.",
    "question.message.overquota.2"         : "Gracias por su tiempo y cooperación.",
    "question.message.error"               : "Puede que haya un problema con la confirmación de su cita. Póngase en contacto con nuestro responsable de reservas enviando un mensaje de correo electrónico a qual@surveyhealthcareglobal.com y mencione el N.º de proyecto que figura en su invitación",
    "minutes" : "minutos",
    // NEW OR ADDED FROM OTHER FILES OR CONST
    "select.time.for.interview"            : "Seleccione un horario para su entrevista",
    "all.times.are.in"                     : "Todos los horarios se expresan en <>.",
    "question.time_slots.none"             : "Ninguno de los horarios de la lista me resulta conveniente Especificaré mi disponibilidad a continuación.",
    "question.comments"                    : "Comentarios",
    "scheduler.link.submit"                : "Enviar",
    "question.text_placeholder"            : "Responda aquí...",
    // MONTHS
    "January"                              : "enero",
    "February"                             : "febrero",
    "March"                                : "marzo",
    "April"                                : "abril",
    "May"                                  : "mayo",
    "June"                                 : "junio",
    "July"                                 : "julio",
    "August"                               : "agosto",
    "September"                            : "septiembre",
    "October"                              : "octubre",
    "November"                             : "noviembre",
    "December"                             : "diciembre",
    // DAYS OF THE WEEK
    "Monday"                               : "Lunes",
    "Tuesday"                              : "Martes",
    "Wednesday"                            : "Miércoles",
    "Thursday"                             : "Jueves",
    "Friday"                               : "Viernes",
    "Saturday"                             : "Sábado",
    "Sunday"                               : "Domingo",
    
    // OPEN SLOTS
    "open.slots"                           : "horario(s) disponible(s)"
}